<template lang="pug">
    section.purchase-form-main(:class="{ loaded: form && form.id }" v-loading="loading")
        .grid
            table.summary.summary-card
                tr
                    td
                        //- b #
                        nobr {{ $t('ID') }}
                    td.col-right
                        b {{ form.id }}
                tr(v-if="invoice_nr")
                    td
                        nobr {{ $t('Invoice Nr.') }}
                    td.col-right
                        nobr {{ invoice_nr }}
                tr
                    td
                        nobr {{ $t('Status') }}
                    td.col-right
                        nobr {{ $t(status) }}

                tr(v-if="inactive && indicators.length")
                    td
                        nobr {{ $t('Color indicators') }}
                    td.col-right
                        nobr.indicators
                            span.indicator(
                                v-for="indicator in indicators"
                                :class="indicator.type"
                            )
                tr(v-else-if="!inactive")
                    td
                        nobr {{ $t('Color indicators') }}
                    td.col-right
                        nobr.indicators.el-loading-parent--relative
                            .spinner(v-if="options.indicator.loading")
                            a.indicator.is-outlined(
                                v-else
                                v-for="indicator in options.indicator.items"
                                :class="[ indicator.type, { active: indicators.find(el => el.id === indicator.id) } ]"
                                href="#"
                                @click.prevent.stop="toggleIndicator(indicator)"
                            )
                                i.el-icon-fa-check.fas(v-if="indicators.find(el => el.id === indicator.id)")

                tr(v-if="form.sold_by === 'point-of-sale'")
                    template(v-if="form.pointOfSale")
                        td(valign="top")
                            nobr {{ $t('Sold by') }}
                        td.col-right
                            component(:is="form.pointOfSale.name && form.pointOfSale.name.length <= 30 ? 'nobr' : 'p'")
                                | {{ form.pointOfSale.name }}

                tr(v-if="form.sold_by && form.sold_by !== 'web-shop' && form.sold_by !== 'point-of-sale'")
                    td(valign="top")
                        nobr {{ $t('Sold by') }}
                    td.col-right
                        component(:is="form.sold_by.length <= 30 ? 'nobr' : 'p'")
                            | {{ form.sold_by }}

                tr(v-if="form.sold_to !== 'point-of-sale'")
                    td(colspan="2")
                        hr

                tr(v-if="form.checkboxes && form.checkboxes.length")
                    td(colspan="2")
                        .mb-1 {{ $t('Checkboxes') }}
                        template(v-for="checkbox in form.checkboxes")
                            component(:key="checkbox.id" :is="!checkbox.label || checkbox.label.length <= 30 ? 'nobr' : 'p'")
                                i.el-icon-fa-check-square.fas(v-if="checkbox.checked" style="color: #67C23A; margin-right: 4px;")
                                i.el-icon-fa-square.far(v-else style="color: #DCDFE6; margin-right: 4px;")
                                span {{ checkbox.label || checkbox.type }}

                tr(v-if="form.sold_to !== 'point-of-sale'")
                    td(valign="top")
                        nobr {{ $t('Payment method') }}
                    td.col-right
                        template(v-if="payment_method_name")
                            component(:is="payment_method_name.length <= 30 ? 'nobr' : 'p'")
                                | {{ $t(payment_method_name) }}
                        nobr(v-else) {{ $t('undefined') }}

                //- Nothing to deliver, nothing to name. A ticket or coupon order carries no method at
                //- all, and the row rendered "Shipping method: undefined" over an order that is
                //- delivered by email.
                tr(v-if="form.sold_by !== 'point-of-sale' && form.sold_to !== 'point-of-sale' && form.requires_shipping !== false")
                    td(valign="top")
                        nobr {{ $t('Shipping method') }}
                    td.col-right
                        template(v-if="shipping_method_name")
                            component(:is="shipping_method_name.length <= 30 ? 'nobr' : 'p'")
                                | {{ $t(shipping_method_name) }}
                        nobr(v-else) {{ $t('undefined') }}

                tr(v-if="tracking_nr")
                    //- td {{ $t('Delivery by {company}', { company: 'UPS' }) }}
                    td {{ $t('Tracking nr') }}
                    td.min.col-right
                        nobr
                            a {{ tracking_nr }}

                tr(v-if="should_be_delivered_at")
                    td {{ $t('Desired delivery date') }}
                    td.min.col-right
                        nobr {{ should_be_delivered_at | timestamp2date($t('yyyy-MM-dd')) }}

                template(v-if="currency")

                    template(v-if="summary && summary.length" )

                        tr.no-margin-bottom
                            td(colspan="2")
                                hr

                        tr.show-details-button
                            td(colspan="2")
                                el-button(
                                    size="mini"
                                    type="text"
                                    :icon="showDetailedSummary ? 'el-icon-fa-chevron-up fas' : 'el-icon-fa-chevron-down fas'"
                                    @click.stop="showDetailedSummary = !showDetailedSummary"
                                )
                                    template(v-if="showDetailedSummary === false") {{ $t('show details') }}
                                    template(v-else) {{ $t('hide details') }}

                        template(v-if="showDetailedSummary")
                            tr(v-for="row in summary")
                                td
                                    //- nobr(v-if="couponPercentage && row.key.startsWith('discount-percentage')")
                                    //-     | {{ $t('{percentage}% Discount', { percentage: couponPercentage }) }}
                                    nobr(v-if="row.key.startsWith('coupon')") {{ row.label }}
                                    nobr(v-else) {{ $t(row.key) }}
                                td.col-right
                                    //- nobr(v-if="row.key.startsWith('discount') || row.key.startsWith('credit')") -{{ row.amount | moneyFormat(currency) }}
                                    nobr(v-if="row.key.startsWith('coupon')") -{{ row.amount | moneyFormat(currency) }}
                                    nobr(v-else) {{ row.amount | moneyFormat(currency) }}
                            tr.summary-divider
                                td(colspan="2")
                                    hr

                    template(v-else)

                        tr
                            td(colspan="2")
                                hr

                    tr(v-if="tax_total")
                        td
                            nobr {{ $t('VAT included') }}
                        td.col-right
                            nobr {{ tax_total | moneyFormat(currency) }}
                    tr
                        td
                            nobr {{ $t('Grand total') }}
                        td.col-right
                            nobr
                                b {{ grand_total | moneyFormat(currency) }}

                template(v-else)
                    //- TODO: error message

            .details.grow
                Documents(
                    :form="form"
                    :date-time-format="dateTimeFormat"
                    :stock-options="stockOptionsForReturns"
                    :currency="currencySymbolForReturns"
                    @send-confirmation="showPurchaseConfirmationEmailDialog"
                    @view-confirmation-pdf="showPurchaseConfirmationPdfDialog"
                    @send-invoice="showInvoiceEmailDialog"
                    @view-invoice-pdf="showInvoicePdfDialog"
                    @render-receipt-pdf="renderReceiptPDF"
                    @view-receipt-pdf="showReceiptPdfDialog"
                    @send-credit-note="showCreditNoteEmailDialog"
                    @view-credit-note-pdf="showCreditNotePdfDialog"
                    @view-cancellation-receipt-pdf="showCancellationReceiptPdfDialog"
                    @view-delivery-note-pdf="showDeliveryNotePdfDialog"
                    @view-packing-list-pdf="showPackingListPdfDialog"
                    @view-shipping-package-slip-pdf="showShippingPackageSlipPdfDialog"
                    @open-shipment-label="openShipmentLabel"
                    @get-ups-return-label="getUpsReturnLabel"
                    @send-shipping-confirmation="showShippingConfirmationEmailDialog"
                    @approve-return="approveCancellation"
                    @resend-return-received="showReturnReceivedEmailDialog"
                    @resend-return-status-changed="showReturnStatusChangedEmailDialog"
                    @refresh-purchase="refreshAfterReturnAction"
                )

                //- Statusänderung — the last customer interaction that had no
                //- panel of its own. Same ArtifactCard language as the cards
                //- above, so the toggle that decides what the next Save mails
                //- out reads as part of the same column instead of floating
                //- naked underneath it.
                ArtifactCard(
                    v-if="statusChangeSentEmails.length || canNotifyStatusChange"
                    :title="$t('Status change')"
                    icon="el-icon-fa-arrows-rotate"
                    :trackable="false"
                    :date-time-format="dateTimeFormat"
                )
                    //- One row per dispatched status mail, newest last, same
                    //- head + strip shape as the shipping-confirmation blocks.
                    .status-change-block(
                        v-for="sentEmail in statusChangeSentEmails"
                        :key="`status-change-${sentEmail.id}`"
                    )
                        .status-change-block__head
                            .status-change-block__title {{ sentEmail.subject || $t('Status change') }}
                            nobr.status-change-block__date {{ sentEmail.created_at | timestamp2date(dateTimeFormat) }}
                        EngagementStrip(
                            :sent-email="sentEmail"
                            :date-time-format="dateTimeFormat"
                        )

                    .status-change-form(v-if="canNotifyStatusChange")
                        el-switch(
                            :active-text="$t('Notify customer via email')"
                            v-model="notify"
                        )

                        transition(name="slide-decent-vertical")
                            .status-change-notification(v-if="notify")
                                transition(name="slide-decent-vertical")
                                    .flex-row(v-if="statusChangeNotification && statusChangeNotification.status && statusChangeNotification.status.key === 'shipped'")
                                        el-form-item(:label="$t('Shipping service')")
                                            el-select(
                                                v-model="statusChangeNotificationShippingMethodService"
                                                placeholder=""
                                            )
                                                el-option(
                                                    v-for="item in services"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id"
                                                )
                                        el-form-item.grow(
                                            v-if="statusChangeNotification.shipping_method_service != 'custom'"
                                            :label="$t('Tracking code')"
                                        )
                                            el-input(type="text" v-model="statusChangeNotificationTrackingCode")
                                        el-form-item.grow(v-else :label="$t('Shipping service name')")
                                            el-input(type="text" v-model="statusChangeNotificationShippingMethodName")
                                el-form-item.no-margin(:label="$t('Additional text in e-mail')")
                                    el-input(
                                        type="textarea"
                                        :autosize="{ minRows: 4, maxRows: 40 }"
                                        v-model="statusChangeNotificationCommentary"
                                    )

            .timeline
                el-timeline
                    el-timeline-item(
                        v-for="(log, i) in logs"
                        :key="log.id"
                        :timestamp="log.timestamp"
                        :type="log.type"
                        :class="getTailClass(i)"
                        :icon="log.icon"
                        size="large"
                    )
                        h4(v-if="log.heading") {{ log.heading }}
                        p(v-if="log.content") {{ log.content }}
                        template(slot="dot")
                            component.el-timeline-item__node.el-timeline-item__node--large(
                                v-if="inactive"
                                :is="log.component"
                                :class="`el-timeline-item__node--${log.type}`"
                                type="button"
                                @click="toggleStatus(log.status)"
                            )
                                i.el-timeline-item__icon(
                                    v-if="log.icon"
                                    :class="`${log.icon}`"
                                )
                            template(v-else)
                                component.el-timeline-item__node(
                                    v-if="log.type"
                                    :is="log.component"
                                    :class="[`el-timeline-item__node--${log.type}`, `el-timeline-item__node--${log.size || 'large'}`]"
                                    type="button"
                                    @click="toggleStatus(log.status)"
                                )
                                    i.el-timeline-item__icon(
                                        v-if="log.icon"
                                        :class="`${log.icon}`"
                                    )
                                button.el-timeline-item__node.el-timeline-item__node--huge(
                                    v-else
                                    type="button"
                                    @click="toggleStatus(log.status)"
                                )

        el-drawer.email(
            :title="modal.title"
            :visible.sync="modal.visibility"
            :wrapper-closable="false"
            :modal="true"
            :size="modal.size"
            :class="modal.context"
            @open="fitDocumentDrawer"
            @closed="resetModal"
        )
            template(v-if="modal.type === 'email-preview'")
                el-form(v-loading="modal.loading || (modal.data && modal.data.preview && modal.data.preview.loading)")
                    template(v-if="modal.error === false")
                        transition(name="slide-decent-vertical")
                            .meta(v-if="modal.loading === false && (modal.data && !modal.data.preview)")
                                .from-to
                                    .from
                                        b {{ $t('From') }}:
                                        span.pill {{ modal.data.sender }}
                                    .to
                                        b {{ $t('To') }}:
                                        span.pill(v-for="to in modal.data.recipients") {{ to }}
                                    .cc(v-if="modal.data.ccs.length")
                                        b {{ $t('Cc') }}:
                                        span.pill(v-for="cc in modal.data.ccs") {{ cc }}
                                    .bcc(v-if="modal.data.bccs.length")
                                        b {{ $t('Bcc') }}:
                                        span.pill(v-for="bcc in modal.data.bccs") {{ bcc }}
                                //- Hide the subject row when the underlying mail
                                //- has a hard-coded subject the admin cannot edit
                                //- — avoids implying it could be changed.
                                .subject(v-if="modal.context !== 'return-received-email' && modal.context !== 'return-status-changed-email'")
                                    b {{ $t('Subject') }}:
                                    span {{ modal.data.subject }}
                                .attachments(v-if="modal.data.attachments && modal.data.attachments.length")
                                    b(v-if="modal.data.attachments.length > 1") {{ $t('Attachments') }}
                                    b(v-else) {{ $t('Attachment') }}
                                    ul
                                        li(v-for="attachment in modal.data.attachments")
                                            a(href @click.prevent="previewModalAttachment(attachment)") {{ attachment.name }}
                        section.body
                            iframe(
                                v-show="modal.data && !modal.data.preview"
                                ref="preview-iframe"
                                frameBorder="0"
                                @load="previewLoaded"
                                @error="previewError"
                            )
                            .preview(
                                v-if="modal.data && modal.data.preview"
                                ref="preview"
                                :class="{ loaded: modal.data && modal.data.preview && !modal.data.preview.loading }"
                            )
                                //- vue-pdf
                                pdf(
                                    ref="pdf-preview"
                                    :src="previewUrl"
                                    :page="modal.data.preview.pagination.current"
                                    @num-pages="total => updatePreviewPagination('total', total)"
                                    @loaded="previewLoaded"
                                    @error="previewError"
                                )
                                //- pdf(
                                //-     ref="pdf-preview"
                                //-     :src="previewUrl"
                                //-     @loading="loadingPreview"
                                //- )
                .drawer-footer
                    template(v-if="modal.data && !modal.data.preview")
                        el-button(
                            round
                            size="mini"
                            icon="el-icon-fa-times fas"
                            @click="closeModal"
                        ) {{ $t('Dismiss') }}
                        el-button(
                            v-if="modal.submit"
                            round
                            size="mini"
                            :disabled="modal.loading || modal.saving"
                            :loading="modal.saving"
                            type="primary"
                            icon="el-icon-fa-check fas"
                            @click="submitModal"
                        ) {{ modal.submit }}
                    template(v-else-if="modal.data && modal.data.preview")
                        el-button(
                            v-if="modal.submit"
                            round
                            size="mini"
                            type="info"
                            :disabled="modal.loading || modal.saving"
                            icon="el-icon-fa-arrow-left fas"
                            @click="resetPreviewModal"
                        ) {{ $t('Return to email preview') }}
                        .preview-pagination(v-if="modal.data.preview.pagination && modal.data.preview.pagination.total > 1")
                            el-pagination(
                                small
                                layout="prev, pager, next"
                                :pager-count="5"
                                :page-size="1"
                                :total="modal.data.preview.pagination.total"
                                @current-change="current => updatePreviewPagination('current', current)"
                            )
                        .right-buttons
                            el-button(
                                circle
                                size="mini"
                                type="primary"
                                :disabled="modal.data.preview.loading"
                                icon="el-icon-fa-download fas"
                                @click="downloadPreview"
                            )
                            //- {{ $t('Download') }}
                            el-button(
                                round
                                size="mini"
                                type="primary"
                                :disabled="modal.data.preview.loading"
                                icon="el-icon-fa-print fas"
                                @click="printPreview"
                            ) {{ $t('Print') }}
            template(v-if="modal.type === 'pdf-preview'")
                el-form(v-loading="modal.loading")
                    template(v-if="modal.error === false")
                        section.body
                            .preview(
                                ref="preview"
                                :class="{ loaded: !modal.loading }"
                            )
                                //- vue-pdf
                                pdf(
                                    ref="pdf-preview"
                                    :src="previewUrl"
                                    :page="modal.data.preview.pagination.current"
                                    @num-pages="total => updatePreviewPagination('total', total)"
                                    @loaded="previewLoaded"
                                    @error="previewError"
                                )
                                //- pdf(
                                //-     ref="pdf-preview"
                                //-     :src="previewUrl"
                                //-     @loading="loadingPreview"
                                //- )
                .drawer-footer
                    el-button(
                        round
                        size="mini"
                        icon="el-icon-fa-times fas"
                        @click="closeModal"
                    ) {{ $t('Dismiss') }}
                    .preview-pagination(v-if="modal.data.preview.pagination && modal.data.preview.pagination.total > 1")
                        el-pagination(
                            small
                            layout="prev, pager, next"
                            :pager-count="5"
                            :page-size="1"
                            :total="modal.data.preview.pagination.total"
                            @current-change="current => updatePreviewPagination('current', current)"
                        )
                    .right-buttons
                        el-button(
                            circle
                            size="mini"
                            type="primary"
                            :disabled="modal.loading"
                            icon="el-icon-fa-download fas"
                            @click="downloadPreview"
                        )
                        //- {{ $t('Download') }}
                        el-button(
                            round
                            size="mini"
                            type="primary"
                            :disabled="modal.loading"
                            icon="el-icon-fa-print fas"
                            @click="printPreview"
                        ) {{ $t('Print') }}
            template(v-if="modal.type === 'label-preview'")
                el-form(v-loading="modal.loading")
                    template(v-if="modal.error === false")
                        section.body
                            //- .preview(
                            //-     ref="preview"
                            //-     :class="{ loaded: !modal.loading }"
                            //- )
                            el-image.printThisFull(:src="modal.labelSrc")
                .drawer-footer
                    el-button(
                        round
                        size="mini"
                        icon="el-icon-fa-times fas"
                        @click="closeModal"
                    ) {{ $t('Dismiss') }}
                    el-button(
                        round
                        size="mini"
                        type="primary"
                        :disabled="modal.loading"
                        icon="el-icon-fa-print fas"
                        @click="printLabel"
                    ) {{ $t('Print') }}


        //- el-dialog.status-dialog(
        //-     :title="$t('Send email for status \"{status}\"', { status: $t(sendEmailDialog.status) })"
        //-     :visible.sync="sendEmailDialog.visibility"
        //-     :close-on-click-modal="false"
        //-     top="10vh"
        //-     width="980px"
        //-     @closed="resetEmailModal"
        //- )
        //-     div(v-loading="sendEmailDialog.loading")
        //-         p {{ $t('Here you can optionally send an email to the customer with the updated status of the purchse.') }}
        //-         p.mt-8
        //-         //- p.mt0 {{ $t('Tracking link') }}
        //-         template(v-if="sendEmailDialog.status == 'shipped'")
        //-             el-form-item(:label="$t('Shipping service')")
        //-                 //- el-input(v-model="modal.ship.form.shippingService")
        //-                 el-select(v-model="sendEmailDialog.shipping_method_service")
        //-                     el-option(
        //-                         v-for="item in services"
        //-                         :key="item.id"
        //-                         :label="item.name"
        //-                         :value="item.id"
        //-                     )
        //-             el-form-item(v-if="sendEmailDialog.shipping_method_service != 'custom'" :label="$t('Tracking code')")
        //-                 el-input.mt0(
        //-                     type="text"
        //-                     v-model="sendEmailDialog.tracking_code"
        //-                 )
        //-             el-form-item(v-else :label="$t('Shipping service name')")
        //-                 el-input.mt0(
        //-                     type="text"
        //-                     v-model="sendEmailDialog.shipping_method_name"
        //-                 )
        //-         //- p {{ $t('The additional text field is optional.') }}
        //-         el-form-item(:label="$t('Additional text in e-mail')")
        //-             el-input(
        //-                 type="textarea"
        //-                 :autosize="{ minRows: 4, maxRows: 40 }"
        //-                 v-model="sendEmailDialog.commentary"
        //-             )
        //-         .drawer-footer
        //-             .left
        //-                 el-button(
        //-                     round
        //-                     size="mini"
        //-                     icon="el-icon-fa-times fas"
        //-                     @click="sendEmailDialog.visibility = false"
        //-                 ) {{ $t('Dismiss') }}
        //-             .right.flex-row
        //-                 //- el-button(
        //-                 //-     round
        //-                 //-     size="mini"
        //-                 //-     type="primary"
        //-                 //-     icon="el-icon-fa-check fas"
        //-                 //-     @click="sendStatusEmail"
        //-                 //- ) {{ $t('Save status and send email') }}
        //-                 //- el-button(
        //-                 //-     round
        //-                 //-     size="mini"
        //-                 //-     type="success"
        //-                 //-     icon="el-icon-fa-check fas"
        //-                 //-     @click="sendStatusEmail"
        //-                 //- ) {{ $t('Only save status (without sending email)') }}

        //-                 el-switch(
        //-                     :active-text="$t('Notify customer via email')"
        //-                     v-model="sendEmailDialog.notify"
        //-                 )
        //-                 el-button(
        //-                     round
        //-                     size="mini"
        //-                     type="primary"
        //-                     icon="el-icon-fa-check fas"
        //-                     @click="sendStatusEmail"
        //-                 ) {{ $t('Save status') }}
</template>

<i18n>
{
    "en": {
        "sub-total": "Subtotal",
        "sub-total-net": "Net",
        "discount-total": "Discount",
        "discount-total-net": "Discount",
        "discount-percentage": "Discount",
        "discount-percentage-net": "Discount",
        "shipping-fee": "Shipping fee",
        "shipping-fee-net": "Shipping fee",
        "credited-amount-total": "Credited amount",
        "tax-sum": "VAT",
        "View {stock} PDF": "View {stock} PDF",
        "Package {name}": "Package {name}",
        "Package POS {name}": "Package POS {name}",
        "itemsCanceled": "1 item canceled | {count} items canceled",
        "returnRequestItems": "Return request: 1 item | Return request: {count} items",
        "Return submitted": "Return submitted",
        "Return approved": "Return approved",
        "Return rejected": "Return rejected",
        "Return goods received": "Return goods received",
        "Return reminder sent to customer": "Return reminder sent to customer",
        "Return acknowledgment of receipt sent to customer": "Return acknowledgment of receipt sent to customer",
        "Return status notification sent to customer": "Return status notification sent to customer",
        "Return lookup link sent to customer": "Return lookup link sent to customer",
        "refund_error": {
            "refund_amount_exceeded": "The refund amount exceeds what has been captured for this purchase.",
            "refund_already_fully_refunded": "This capture has already been fully refunded.",
            "paypal_capture_id_missing": "Cannot find the original PayPal capture for this purchase.",
            "stripe_failed": "Stripe declined the refund.",
            "stripe_canceled": "Stripe canceled the refund before settlement.",
            "gateway_error": "The payment provider could not process the refund."
        },
        "{number}. Coupon PDF": "{number}. Coupon PDF",
        "draft": "Draft",
        "new": "New",
        "pending": "Pending",
        "processing": "Processing",
        "on-hold": "On hold",
        "canceled": "Canceled",
        "shipped": "Shipped",
        "closed": "Closed",
        "Send email for status \"{status}\"": "Send email for status \"{status}\"",
        "Delivery by {company}": "Delivery by {company}",
        "{percentage}% Discount": "{percentage}% Discount"
    },
    "de": {
        "Status": "Status",
        "Invoice Nr.": "Rechnungs-Nr.",
        "Invoice created at": "Rechnung erstellt am",
        "Color indicators": "Farbmarker",
        "Sold by": "Verkauft in",
        "Sold by POS": "Kassenverkauf",
        "Point Of Sale": "Kasse",
        "Purchased": "Gekauft",
        "Requested": "Angefordert",
        "Payed": "Bezahlt",
        "On hold": "Zurückgestellt",
        "Canceled": "Storniert",
        "Partially canceled at": "Teilweise storniert am",
        "Partially canceled and email sent at": "Teilweise storniert und Email versendet am",
        "itemsCanceled": "1 Artikel storniert | {count} Artikel storniert",
        "returnRequestItems": "Widerruf-Anfrage: 1 Artikel | Widerruf-Anfrage: {count} Artikel",
        "Return submitted": "Widerruf eingereicht",
        "Return approved": "Widerruf genehmigt",
        "Return rejected": "Widerruf abgelehnt",
        "Return goods received": "Widerruf abgeschlossen - Bestand aktualisiert",
        "Return reminder sent to customer": "Widerruf-Erinnerung an den Kunden versandt",
        "Return acknowledgment of receipt sent to customer": "Widerruf-Eingangsbestätigung an den Kunden versandt",
        "Return status notification sent to customer": "Widerruf-Statusbenachrichtigung an den Kunden versandt",
        "Return lookup link sent to customer": "Widerruf-Link an den Kunden versandt",
        "refund_error": {
            "refund_amount_exceeded": "Der Erstattungsbetrag übersteigt den ursprünglich vereinnahmten Betrag dieser Bestellung.",
            "refund_already_fully_refunded": "Diese Zahlung wurde bereits vollständig erstattet.",
            "paypal_capture_id_missing": "Die ursprüngliche PayPal-Transaktion für diese Bestellung wurde nicht gefunden.",
            "stripe_failed": "Stripe hat die Erstattung abgelehnt.",
            "stripe_canceled": "Stripe hat die Erstattung vor der Abwicklung abgebrochen.",
            "gateway_error": "Der Zahlungsdienstleister konnte die Erstattung nicht verarbeiten."
        },
        "Resend acknowledgment of receipt": "Eingangsbestätigung erneut versenden",
        "Resend status notification": "Statusbenachrichtigung erneut versenden",
        "Email sent": "E-Mail versendet",
        "Email could not be sent": "E-Mail konnte nicht versendet werden",
        "Pending": "Ausstehend",
        "Approved": "Genehmigt",
        "Rejected": "Abgelehnt",
        "Expired": "Abgelaufen",
        "Approve & refund": "Genehmigen & erstatten",
        "Reject": "Ablehnen",
        "The return has been approved and the refund has been triggered.": "Der Widerruf wurde genehmigt und die Erstattung ausgelöst.",
        "Transition failed": "Statusänderung fehlgeschlagen",
        "Cancel": "Abbrechen",
        "Shipped": "Versendet",
        "Closed": "Geschlossen",
        "VAT included": "Enthaltene MwSt.",
        "Net": "Netto",
        "Sub total": "Zwischensumme",
        "Grand total": "Gesamtbetrag",
        "Order": "Bestellung",
        "Ordered at": "Bestellt am",
        "Checkboxes": "Checkboxen",
        "Payment method": "Zahlungsart",
        "Shipping method": "Versandart",
        "Shipping fee": "Versandkosten",
        "Discount": "Rabatt",
        "{percentage}% Discount": "{percentage}% Rabatt",
        "show details": "Details anzeigen",
        "hide details": "Details verbergen",
        "Coupon PDF": "Gutschein PDF",
        "{number}. Coupon PDF": "{number}. Gutschein PDF",
        "sub-total": "Zwischensumme",
        "sub-total-net": "Netto",
        "discount-total": "Rabatt",
        "discount-total-net": "Rabatt",
        "discount-percentage": "Rabatt",
        "discount-percentage-net": "Rabatt",
        "shipping-fee": "Versandkosten",
        "shipping-fee-net": "Versandkosten",
        "credited-amount-total": "Gutschrift",
        "tax-sum": "MwSt.",
        "View {stock} PDF": "PDF von {stock} anzeigen",
        "Package {name}": "Paket {name}",
        "Package POS {name}": "Paket POS {name}",
        "Confirmation email sent at": "Bestellbestätigung versendet am",
        "Confirmation email has not been sent yet": "Bestellbestätigung wurde noch nicht versendet",
        "Payed at": "Bezahlt am",
        "Not payed": "Nicht bezahlt",
        "has not been sent yet": "wurde noch nicht versendet",
        "Invoice": "Rechnung",
        "Invoice nr": "Rechnung",
        "Invoice PDF": "Rechnung PDF",
        "Invoice has not been generated yet": "Rechnung wurde noch nicht generiert",
        "Invoice email sent successfully!": "Rechnung erfolgreich versendet!",
        "Invoice email could not be sent": "Rechnung konnte nicht versendet werden",
        "Invoice email has not been sent yet": "Rechnung wurde noch nicht versendet",
        "Receipt has not been generated yet": "Kassenbon wurde noch nicht generiert",
        "Invoice email preview could not be rendered": "Rechnung konnte nicht generiert werden",
        "Invoice sent at": "Rechnung versendet am",
        "Send new invoice email": "Neue Rechnung versenden",
        "Refunded": "Erstattet",
        "Refund failed": "Erstattung fehlgeschlagen",
        "Credit Note PDF": "Gutschrift PDF",
        "Credit note has not been generated yet": "Gutschrift wurde noch nicht generiert",
        "Credit note email sent successfully!": "Gutschrift erfolgreich versendet!",
        "Credit note email could not be sent": "Gutschrift konnte nicht versendet werden",
        "Credit note email has not been sent yet": "Gutschrift wurde noch nicht versendet",
        "Credit note email preview could not be rendered": "Gutschrift konnte nicht generiert werden",
        "Credit note sent at": "Gutschrift versendet am",
        "Send new credit note email": "Gutschrift erneut versenden",
        "Send credit note email now": "Gutschrift jetzt versenden",
        "Receipt": "Kassenbon",
        "Receipt created at": "Kassenbon erstellt am",
        "Receipt PDF": "Kassenbon PDF",
        "Generate now": "Jetzt generieren",
        "Generate now and download": "Jetzt generieren und herunterladen",
        "Generate now and print": "Jetzt generieren und drucken",
        "Generate now and send by email": "Jetzt generieren und per Email versenden",
        "Delivery note": "Lieferschein",
        "Delivery note nr": "Lieferscheinnummer",
        "Delivery note PDF": "Lieferschein PDF",
        "Packing slip (shipment labels, return labels)": "Packliste (Versandlabel, Retourenlabel)",
        "Packing slip nr": "Packlistennummer",
        "Packing slip PDF": "Packliste PDF",
        "Delivery tracking": "Lieferung",
        "Tracking nr": "Sendungsnummer",
        "Delivery by {company}": "Lieferung durch {company}",
        "Desired delivery date": "Wunschlieferdatum",
        "Split Payment": "Split-Zahlung",
        "Send new confirmation email": "Neue Bestellbestätigung versenden",
        "Send email now": "Email jetzt versenden",
        "View recently sent email": "Zuletzt versendete Email anzeigen",
        "View attached PDF": "Angehängte PDF anzeigen",
        "Preview could not be rendered": "Vorschau konnte nicht generiert werden",
        "Receipt could not be rendered": "Kassenbon konnte nicht generiert werden",
        "Missing PDF": "PDF konnte nicht gefunden werden",
        "email preview could not be rendered": "Email Vorschau konnte nicht generiert werden",
        "Confirmation email preview could not be rendered": "Bestellbestätigung konnte nicht generiert werden",
        "Confirmation email could not be sent": "Bestellbestäting konnte nicht versendet werden",
        "Confirmation email sent successfully!": "Bestellbestätingung erfolgreich versendet!",
        "Shipping confirmation email preview could not be rendered": "Versandbestätigung konnte nicht generiert werden",
        "View Credit Note PDF": "Gutschrift PDF anzeigen",
        "View PDF": "PDF anzeigen",
        "Generate now and and view PDF": "Jetzt generieren und PDF anzeigen",
        "View full list PDF": "PDF mit vollständiger Liste anzeigen",
        "Attachments": "Anhänge",
        "Attachment": "Anhang",
        "Return to email preview": "Zurück zur Email-Vorschau",
        "Purchase confirmation PDF": "Bestellbestätigung PDF",
        "From": "Von",
        "To": "An",
        "Cc": "Cc",
        "Bcc": "Bcc",
        "Subject": "Betreff",
        "Preview": "Vorschau",
        "Print": "Drucken",
        "Download": "Herunterladen",
        "Email preview": "Email vorschau",
        "Send now": "Jetzt versenden",
        "Send again": "Erneut versenden",
        "draft": "Entwurf",
        "new": "Neu",
        "pending": "Ausstehend",
        "processing": "In Bearbeitung",
        "payed": "Bezahlt",
        "on-hold": "Zurückgestellt",
        "canceled": "Storniert",
        "shipped": "Versendet",
        "closed": "Geschlossen",
        "Shipping label": "Versandlabel",
        "Show shipping label": "Versandlabel anzeigen",
        "Create return label (opens in new tab)": "Return-Label erstellen (öffnet in neuem Tab)",
        "Shipping email sent at": "Versandbestätigung versendet am",
        "Shipping email has not been sent yet": "Versandbestätigung wurde noch nicht versendet",
        "Send shipping email again": "Versandbestätigung erneut versenden",
        "Shipping email could not be sent": "Versandbestätigung konnte nicht versendet werden",
        "Shipping email sent successfully!": "Versandbestätigung erfolgreich versendet!",
        "Shipping confirmations": "Versandbestätigungen",
        "Send email for status \"{status}\"": "E-Mail versenden für Status \"{status}\"",
        "Here you can optionally send an email to the customer with the updated status of the purchse.": "Hier können Sie bei Bedarf eine E-Mail an den Käufer mit dem neuen Status der Bestellung senden.",
        "commentary": "Kommentar",
        "The additional text field is optional.": "Das Ausfüllen des Zusatztextes ist optional.",
        "Email sent successfully!": "E-Mail erfolgreich versendet!",
        "Would you like to send an email to the purchaser with the updated status?": "Möchten Sie eine E-Mail mit der Statusänderung an den Kunden versenden?",
        "No, only save the status": "Nein, nur Status speichern",
        "Yes": "Ja",
        "Save status and send email": "Status speichern und E-Mail versenden",
        "Additional text in e-mail": "Zusatztext in der E-Mail",
        "Only save status (without sending email)": "Nur Status speichern (ohne E-Mail-Versand)",
        "Save status": "Status speichern",
        "Notify customer via email": "Kunden per E-Mail benachrichtigen",
        "Status change": "Statusänderung",
        "Tracking link": "Tracking-Link",
        "Tracking code": "Tracking-Code",
        "Shipping service": "Paketdienst",
        "Shipping service name": "Paketdienst-Name",
        "more / user defined": "Weitere / Benutzerdefiniert",
        "No shipping": "Kein Versand",
        "undefined": "Nicht angegeben",
        "custom": "Individuell",
        "Custom Shipping Method": "Individuelle Versandart",
        "Credit Note": "Gutschrift",
        "Cancellation Receipt": "Stornobeleg"
    }
}
</i18n>

<script>
import _ from 'lodash'
import axios from 'axios';
import printJS from 'print-js-updated';
import { timestamp2date } from '@/filters'
import { adminClient as apolloClient } from '@/store/apollo';
import TransitionCancellationGql from '@/extensions/shop/store/graphql/mutations/TransitionCancellation.gql';
import { differenceInMinutes, isPast } from 'date-fns'

import AuthApi from '@/store/api/system/auth';
import { ensureFreshToken } from '@/helpers';
import pinia from '@/pinia';
import { useAuthStore, useSetupStore, useShopPurchaseStore } from '@/stores'
import PurchaseApi from '@/extensions/shop/store/api/purchase';
import pdf from 'vue-pdf'
import Documents from '@/extensions/shop/views/Purchase/Form/Partials/Documents.vue'
import ArtifactCard from '@/extensions/shop/views/Purchase/Form/Partials/ArtifactCard.vue'
import EngagementStrip from '@/extensions/shop/views/Purchase/Form/Partials/EngagementStrip.vue'
// import pdf from 'pdfvuer'
import UPSApi from '@/extensions/shop/pointOfSale/store/api/ups'
import { a4DrawerSize, a4DrawerSizeEstimate } from '@/utils/a4DrawerSize'

export default {
    name: 'Main',
    data() {
        return {
            showDetailedSummary: false,
            modal: {
                visibility: false,
                type: undefined,
                context: undefined,
                size: '40%',
                title: this.$t('Preview'),
                loading: false,
                saving: false,
                submit: false,
                error: false,
                labelSrc: ''
            },
            // sendEmailDialog: {
            //     visibility: false,
            //     status: '',
            //     commentary: '',
            //     shipping_method_service: '',
            //     shipping_method_name: '',
            //     tracking_code: '',
            //     notify: true,
            //     loading: false
            // },
            rendering: {
                receipt: false,
            },
            loading: false,
            currentPackageId: null,
            services: [
                { id: 'dhl', name: 'DHL' },
                { id: 'gls', name: 'GLS' },
                { id: 'hermes', name: 'Hermes' },
                { id: 'ups', name: 'UPS' },
                { id: 'click-and-collect', name: 'Click & Collect' },
                { id: 'custom', name: this.$t('more / user defined') },
                { id: 'none', name: this.$t('No shipping') },
            ]
        };
    },
    components: {
        pdf,
        Documents,
        ArtifactCard,
        EngagementStrip,
    },
    filters: {
        timestamp2date,
    },
    computed: {
        inactive() {
            // 'closed', 'canceled'
            return ['new', 'undefined'].includes(this.status) || !this.id || this.form.canceled_at || this.form.closed_at;
        },
        id() {
            return _.get(this.form, 'id')
        },
        invoice_nr() {
            return _.get(this.form, 'invoice_nr', '')
        },
        invoice_created_at() {
            return _.get(this.form, 'invoice_created_at', '')
        },
        invoice_sent_at() {
            return _.get(this.form, 'invoice_email_sent_at', '')
        },
        delivery_note_nr() {
            return _.get(this.form, 'delivery_note_nr', '')
        },
        delivery_note_created_at() {
            // TODO: get from file created_at
            return false;
        },
        packing_list_nr() {
            return _.get(this.form, 'packing_list_nr', '')
        },
        packing_list_created_at() {
            // TODO: get from file created_at
            return false;
        },
        should_be_delivered_at() {
            return _.get(this.form, 'should_be_delivered_at')
        },
        receipt() {
            return _.get(this.form, 'latestReceipt')
        },
        receipt_created_at() {
            return _.get(this.receipt, 'created_at')
        },
        tracking_nr() {
            return _.get(this.form, 'tracking_nr', '')
        },
        updated_at() {
            return _.get(this.form, 'updated_at', '')
        },
        created_at() {
            return _.get(this.form, 'created_at', '')
        },
        confirmation_email_sent_at() {
            return _.get(this.form, 'confirmation_email_sent_at', '')
        },
        shipping_email_sent_at() {
            return _.get(this.form, 'shipping_email_sent_at', '')
        },
        status() {
            return _.get(this.form, 'status.key', 'undefined')
        },
        indicators() {
            return _.get(this.form, 'indicators') || []
        },
        // Every mail this panel's toggle has produced. UpdatePurchase sends
        // one of TWO jobs off the same switch: SendPurchaseStatusMail when the
        // save also carried a status change, SendPurchaseUpdatedMail when only
        // a commentary was written. Matching just the former left a
        // commentary-only send with no row at all.
        statusChangeSentEmails() {
            const types = ['purchase-status-changed', 'purchase-updated']
            const rows = _.get(this.form, 'sentEmails') || []
            return rows.filter(sentEmail => types.includes(sentEmail.type))
        },
        // The toggle only makes sense while the purchase can still change
        // status. The sent rows above stay visible regardless, so a closed or
        // canceled order keeps its mail history.
        canNotifyStatusChange() {
            return !this.inactive && !!_.get(this.form, 'purchaser.email')
        },
        closed_at() {
            return _.get(this.form, 'closed_at', '')
        },
        canceled_at() {
            return _.get(this.form, 'canceled_at', '')
        },
        payment_method_name() {
            return _.get(this.form, 'payment_method_name', '')
        },
        payed_at() {
            return _.get(this.form, 'payed_at', '')
        },
        shipping_method_name() {
            return _.get(this.form, 'shipping_method_name', '')
        },
        shipped_at() {
            return _.get(this.form, 'shipped_at', '')
        },

        // summary

        summary() {
            const summary = _.get(this.form, 'detailedSummary') || []
            return summary.filter(el => ['tax-total', 'grand-total'].includes(el.key) === false)
        },

        // showSummaryDetails() {
        //     return this.tax_total || this.discount_total || this.shipping_fee;
        // },
        // showNetDetails() {
        //     // let show = this.sub_total_net !== this.net_total;
        //     // if (this.discount_total > this.discount_total_net) show = true;
        //     // if (!this.shipping_fee > this.shipping_fee_net) show = true;
        //     // return show;

        //     // TODO
        //     return false;
        // },
        // hasOnlyOnePercentageCoupon() {
        //     // TODO
        //     return false;
        // },
        // couponPercentage() {
        //     let percentage;
        //     if (this.coupons && this.coupons.length === 1 && this.coupons[0]['type'] === 'percentage') percentage = this.coupons[0]['percentage'];
        //     return percentage;
        // },
        // sub_total() {
        //     return _.get(this.form, 'sub_total', 0)
        // },
        // sub_total_net() {
        //     return _.get(this.form, 'sub_total_net', 0)
        // },
        // discount_total() {
        //     return _.get(this.form, 'discount_total', 0)
        // },
        // discount_total_net() {
        //     return _.get(this.form, 'discount_total_net', 0)
        // },
        coupons() {
            return _.get(this.form, 'coupons') || []
        },
        // shipping_fee() {
        //     return _.get(this.form, 'shipping_fee', 0)
        // },
        // shipping_fee_net() {
        //     return _.get(this.form, 'shipping_fee_net', 0)
        // },
        // // shiping_tax() {
        // //     return _.get(this.form, 'shiping_tax', 0)
        // // },
        // // shipping_fee_tax_amount() {
        // //     return _.get(this.form, 'shipping_fee_tax_amount', 0)
        // // },
        // net_total() {
        //     let netTotal = this.sub_total_net;
        //     if (this.discount_total > this.discount_total_net) {
        //         netTotal -= this.discount_total_net;
        //     }
        //     if (!this.shipping_fee > this.shipping_fee_net) {
        //         netTotal += this.shipping_fee_net;
        //     }
        //     return netTotal;
        // },
        tax_total() {
            return _.get(this.form, 'tax_total', 0)
        },
        grand_total() {
            return _.get(this.form, 'grand_total', 0)
        },

        currency() {
            return _.get(this.form, 'currency')
        },
        logs() {
            let log, timestamp
            let logs = [{
                component: 'div',
                status: 'new',
                key: 'created_at',
                heading: this.form.sold_to !== 'point-of-sale' ? this.$t('Purchased') : this.$t('Requested'),
                timestamp: timestamp2date(this.created_at, this.dateTimeFormat),
                position: this.created_at,
                type: 'success',
                icon: 'el-icon-fa-check fas'
            }]

            let statusLogs = _.get(this.form, 'statusLogs') || []

            // summarize
            let summarized = {}
            statusLogs.forEach(statusLog => {
                summarized[statusLog.key] = statusLog
            })

            statusLogs = Object.values(summarized)
            // The backend writes Widerruf-related status-log rows with a hard
            // coded German heading + body for clarity in DB inspection. The
            // timeline below maps the row's `key` back to a locale-aware
            // single-line label so the UI follows the user's language and
            // doesn't double-print "Widerruf" + body.
            const returnLogLabels = {
                'return-approved': 'Return approved',
                'return-rejected': 'Return rejected',
                'return-received-goods': 'Return goods received',
                'return-mail-return-received': 'Return acknowledgment of receipt sent to customer',
                'return-mail-return-status-changed': 'Return status notification sent to customer',
                'return-mail-return-reminder': 'Return reminder sent to customer',
                'return-mail-return-lookup-link': 'Return lookup link sent to customer',
            };

            // `return-submitted` is intentionally NOT rendered: the cancellation
            // row itself produces a per-return "Widerruf-Anfrage: N Artikel"
            // timeline entry below, which already covers the same event. The
            // audit-log row stays in the DB for compliance, just not in the UI.
            const timelineSuppressed = new Set(['return-submitted']);

            statusLogs = statusLogs.filter(log => ! timelineSuppressed.has(log.key));

            statusLogs.forEach(statusLog => {

                let icon = 'el-icon-fa-times fas'
                if (statusLog.status === 'warning') icon = 'el-icon-fa-exclamation fas'
                if (statusLog.status === 'success') icon = 'el-icon-fa-check fas'
                if (statusLog.status === 'pending') icon = 'el-icon-fa-hourglass-half fas'
                if (statusLog.status === 'info') icon = 'el-icon-fa-circle-info fas'

                let type = 'danger'
                if (statusLog.status === 'pending') type = 'primary'
                else if (statusLog.status !== 'error') type = statusLog.status

                let heading = statusLog.heading;
                let content = statusLog.body;
                const localizedKey = returnLogLabels[statusLog.key];
                if (localizedKey) {
                    heading = this.$t(localizedKey);
                    content = null;
                }

                // Refund failures carry a stable error_code in statusLog.data
                // so the timeline can render a friendly localized line per
                // locale (e.g. "Erstattungsbetrag übersteigt die ursprüngliche
                // Zahlung") instead of the raw English gateway message. We
                // KEEP the heading (payment method name like "PayPal") and
                // replace the body with the translated explanation.
                const errorCode = _.get(statusLog, 'data.error_code');
                if (statusLog.key === 'purchase-refund' && errorCode) {
                    content = this.$t(`refund_error.${errorCode}`);
                }

                logs.push({
                    component: 'div',
                    status: statusLog.key,
                    key: 'created_at',
                    heading,
                    content,
                    timestamp: timestamp2date(statusLog.created_at, this.dateTimeFormat),
                    position: statusLog.created_at,
                    type,
                    icon
                })
            })

            // check if there is a log entry
            // for "payed"

            if (!logs.find(el => el.status === 'payed') && this.form.sold_to !== 'point-of-sale') {
                log = {
                    // component: 'button',
                    component: 'div',
                    status: 'payed',
                    heading: this.$t('Payed')
                }
                timestamp = timestamp2date(this.payed_at, this.dateTimeFormat)
                if (timestamp) {
                    if (this.payed_at <= this.updated_at) log.component = 'div'
                    log = {
                        ...log, ...{
                            timestamp,
                            position: this.payed_at,
                            type: 'success',
                            icon: 'el-icon-fa-check fas'
                        }
                    }
                } else if (this.form.status && this.form.status.key === 'payed') {
                    log.component = 'button'
                    log.type = 'active'
                    // log.size = 'huge'
                }
                logs.push(log)
            }

            // check if there is a log entry
            // for "shipped"

            const shippingMethodService = _.get(this.form, 'shipping_method_service', '')
            // Two reasons there is nothing to ship, and this knew only one: the buyer collects it,
            // or the order has nothing physical in it. A ticket carries no method at all, so the
            // service is null, the indexOf check said "not a pickup method" and the timeline offered
            // a Shipped step for something delivered by email.
            const shippingRequiresDelivery = ['click-and-collect', 'none'].indexOf(shippingMethodService) === -1
                && _.get(this.form, 'requires_shipping') !== false

            if (!logs.find(el => el.status === 'shipped') && this.form.sold_by !== 'point-of-sale' && shippingRequiresDelivery) {
                log = {
                    // component: 'button',
                    component: 'div',
                    status: 'shipped',
                    heading: this.$t('Shipped')
                }
                timestamp = timestamp2date(this.shipped_at, this.dateTimeFormat)
                if (timestamp) {
                    if (this.shipped_at <= this.updated_at) log.component = 'div'
                    log = {
                        ...log, ...{
                            timestamp,
                            position: this.shipped_at,
                            type: 'success',
                            icon: 'el-icon-fa-check fas'
                        }
                    }
                } else if (this.form.status && this.form.status.key === 'shipped') {
                    log.component = 'button'
                    log.type = 'active'
                    // log.size = 'huge'
                }
                logs.push(log)
            }

            if (this.form.cancellations && this.form.cancellations.length) {
                this.form.cancellations.forEach(cancellation => {
                    const isReturn = cancellation.type === 'return';
                    let heading = isReturn
                        ? this.$t('Return submitted')
                        : this.$t('Partially Canceled');
                    if (cancellation.items && cancellation.items.length) {
                        const count = cancellation.items.reduce((acc, item) => acc + _.get(item, 'pivot.qty', 0), 0);
                        heading = isReturn
                            ? this.$tc('returnRequestItems', count, { count })
                            : this.$tc('itemsCanceled', count, { count })
                    }
                    log = {
                        // component: 'button',
                        component: 'div',
                        status: 'partially-canceled',
                        heading,
                        // content: cancellation.comment
                    }
                    timestamp = timestamp2date(cancellation.created_at, this.dateTimeFormat)
                    if (timestamp) {
                        if (cancellation.created_at <= this.updated_at) log.component = 'div'
                        log = {
                            ...log, ...{
                                timestamp,
                                position: cancellation.created_at,
                                type: 'danger',
                                icon: 'el-icon-fa-times fas'
                            }
                        }
                    } else if (this.form.status && this.form.status.key === 'canceled') {
                        log.component = 'button'
                        log.type = 'active'
                        // log.size = 'huge'
                    }
                    logs.push(log)
                })
            }

            // check if there is a log entry
            // for "closed"

            if (!logs.find(el => el.status === 'closed')) {
                log = {
                    // component: 'button',
                    component: 'div',
                    status: 'closed',
                    heading: this.$t('Closed')
                }
                timestamp = timestamp2date(this.closed_at, this.dateTimeFormat)
                if (timestamp) {
                    if (this.closed_at <= this.updated_at) log.component = 'div'
                    log = {
                        ...log, ...{
                            timestamp,
                            // position: this.closed_at,
                            type: 'success',
                            icon: 'el-icon-fa-check fas'
                        }
                    }
                } else if (this.form.status && this.form.status.key === 'closed') {
                    log.component = 'button'
                    log.type = 'active'
                    // log.size = 'huge'
                }
                logs.push(log)
            }

            // check if there is a log entry
            // for "canceled"

            if (!logs.find(el => el.status === 'canceled')) {
                log = {
                    // component: 'button',
                    component: 'div',
                    status: 'canceled',
                    heading: this.$t('Canceled')
                }
                timestamp = timestamp2date(this.canceled_at, this.dateTimeFormat)
                if (timestamp) {
                    if (this.canceled_at <= this.updated_at) log.component = 'div'
                    log = {
                        ...log, ...{
                            timestamp,
                            position: this.canceled_at,
                            type: 'danger',
                            icon: 'el-icon-fa-times fas'
                        }
                    }

                    // show only if actually canceled
                    logs.push(log)
                }
            }

            // Canceled is terminal: the steps it never reached are not going to happen, so they
            // come off the timeline instead of dangling in gray below the cancellation.
            if (this.canceled_at) {
                logs = logs.filter(log => log.timestamp)
            }

            // Chronological, with the cancellation after everything that shares its second: it
            // reads as the outcome of that moment, not as a step on the way to the next one.
            return _.orderBy(logs, ['position', log => log.status === 'canceled' ? 1 : 0])
        },
        previewUrl() {
            if (!_.get(this.modal, 'data.preview')) return false
            return this.modal.data.preview.getUrl();
        },
        dateTimeFormat() {
            const template = this.$t('yyyy-MM-dd')
            return `${template}, HH:mm`
        },
        notify: {
            get() {
                return this.form.notify
            },
            set(value) {
                this.setNotify(value)
            }
        },
        statusChangeNotification: {
            get() {
                return this.form.statusChangeNotification
            },
            set(value) {
                this.setStatusChangeNotification(value)
            }
        },
        statusChangeNotificationShippingMethodService: {
            get() {
                return _.get(this.form, 'statusChangeNotification.shipping_method_service')
            },
            set(value) {
                this.setStatusChangeNotificationShippingMethodService(value)
            }
        },
        statusChangeNotificationTrackingCode: {
            get() {
                return _.get(this.form, 'statusChangeNotification.tracking_code')
            },
            set(value) {
                this.setStatusChangeNotificationTrackingCode(value)
            }
        },
        statusChangeNotificationShippingMethodName: {
            get() {
                return _.get(this.form, 'statusChangeNotification.shipping_method_name')
            },
            set(value) {
                this.setStatusChangeNotificationShippingMethodName(value)
            }
        },
        statusChangeNotificationCommentary: {
            get() {
                return _.get(this.form, 'statusChangeNotification.commentary')
            },
            set(value) {
                this.setStatusChangeNotificationCommentary(value)
            }
        },
        shopPurchaseStore() {
            return useShopPurchaseStore(pinia);
        },
        form() {
            return this.shopPurchaseStore.form;
        },
        options() {
            return this.shopPurchaseStore.options;
        },
        stockOptionsForReturns() {
            return _.get(this.options, 'stock.items') || [];
        },
        currencySymbolForReturns() {
            return this.currency || '€';
        },
        history() {
            return this.shopPurchaseStore.history;
        },
        setupStore() {
            return useSetupStore(pinia);
        },
        activeCms() {
            return this.setupStore.activeCms;
        },
        cSrc() {
            const token = AuthApi.getToken()
            return `http://127.0.0.1:3000/storage/private/files/10943780/test3.gif?token=${token}`
        }
    },
    methods: {
        // Called by Returns.vue → Documents.vue (refresh-purchase event) after
        // any of the new drawer actions completes — the drawer already
        // executed its mutation, we just need to repull purchase state so
        // the UI reflects received_at / refunded_at / new status-log rows.
        async refreshAfterReturnAction() {
            try {
                await this.fetchPurchase(this.form.id, 'network-only');
            } catch (err) {
                console.error(err);
            }
        },
        async approveCancellation(cancellation) {
            try {
                await this.transitionCancellation(cancellation, 'approved');
                this.$notify.success({
                    title: this.$t('Approved'),
                    message: this.$t('The return has been approved and the refund has been triggered.'),
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 4000,
                });
                // network-only because the cache-first path can return stale
                // sentEmails / status-log rows that the transition just generated.
                await this.fetchPurchase(this.form.id, 'network-only');
            } catch (err) {
                console.error(err);
                this.$notify.error({
                    title: this.$t('Transition failed'),
                    message: err.message || '',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 6000,
                });
            }
        },
        // rejectCancellation lived here as a bare $confirm. Rejecting now
        // requires stating a cause, so it moved into RejectReturnDrawer.vue
        // (sibling of ApproveRefundDrawer), which owns the mutation itself and
        // reports back through Returns.vue's `refresh` event.
        showReturnReceivedEmailDialog(cancellation) {
            this.openReturnEmailDialog(cancellation, 'return-received');
        },
        showReturnStatusChangedEmailDialog(cancellation) {
            this.openReturnEmailDialog(cancellation, 'return-status-changed');
        },
        // Mirrors showCreditNoteEmailDialog: opens the shared email-preview
        // modal, fetches the rendered subject + iframe body from the existing
        // PreviewController endpoint, lets the admin re-send via submitModal.
        openReturnEmailDialog(cancellation, scope) {
            let sender = this.activeCms.name.trim();
            if (this.activeCms.smtp) sender = `${this.activeCms.smtp.name || this.activeCms.name} <${this.activeCms.smtp.username}>`.trim();
            const purchaser = `${this.form.purchaser.first_name} ${this.form.purchaser.last_name} <${this.form.purchaser.email}>`.trim();
            const bcc = `${this.activeCms.owner.user.name} <${this.activeCms.owner.user.email}>`.trim();

            const payload = {
                subject: '',
                sender,
                recipients: [purchaser],
                ccs: [],
                bccs: [bcc],
                attachments: [],
            };
            this.$set(this.modal, 'data', payload);

            this.modal.type = 'email-preview';
            this.modal.context = scope === 'return-received' ? 'return-received-email' : 'return-status-changed-email';
            this.modal.title = this.$t('Email preview');
            this.modal.visibility = true;
            this.modal.loading = true;
            this.modal.submit = this.$t('Send email now');

            this.modal.data.cancellation = cancellation;
            this.modal.data.scope = scope;

            this.$nextTick(() => {
                const iframe = this.$refs['preview-iframe'];
                const renderer = scope === 'return-received'
                    ? PurchaseApi.renderReturnReceived(cancellation.id)
                    : PurchaseApi.renderReturnStatusChanged(cancellation.id);
                renderer
                    .then(({ data }) => {
                        payload.subject = data.subject;
                        iframe.contentWindow.document.open();
                        iframe.contentWindow.document.write(data.document);
                        iframe.contentWindow.document.close();
                    })
                    .catch(() => {
                        this.modal.submit = false;
                        this.modal.error = true;
                        this.$notify.error({
                            title: this.$t('An error occurred!'),
                            message: this.$t('email preview could not be rendered'),
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000,
                        });
                    })
                    .finally(() => {
                        this.modal.loading = false;
                    });
            });
        },
        async transitionCancellation(cancellation, status, rejectionReason = null) {
            const cancellationId = parseInt(_.get(cancellation, 'id'));
            if (!Number.isFinite(cancellationId)) {
                console.error('transitionCancellation: cancellation has no id', cancellation);
                throw new Error(this.$t('Cancellation row has no id — please refresh and try again.'));
            }
            return apolloClient.mutate({
                mutation: TransitionCancellationGql,
                variables: {
                    id: cancellationId,
                    status,
                    rejection_reason: rejectionReason,
                },
            });
        },
        upsRefreshNeeded() {
            let upsToken = JSON.parse(localStorage.getItem("upstoken"))

            if (upsToken && upsToken.expires_in) {
                let expTime = parseInt(upsToken.issued_at) + parseInt((upsToken.expires_in * 1000));
                const expirationDate = new Date(expTime)
                const minutesLeft = differenceInMinutes(expirationDate, new Date)
                const expired = isPast(expirationDate)
                if (minutesLeft < 60 || expired) return true
            }
            return false
        },
        showInvoiceEmailDialog() {
            let sender = this.activeCms.name.trim();
            if (this.activeCms.smtp) sender = `${this.activeCms.smtp.name || this.activeCms.name} <${this.activeCms.smtp.username}>`.trim();
            const purchaser = `${this.form.purchaser.first_name} ${this.form.purchaser.last_name} <${this.form.purchaser.email}>`.trim();
            let bcc = `${this.activeCms.owner.user.name} <${this.activeCms.owner.user.email}>`.trim();
            if (this.activeCms.shop.email) bcc = this.activeCms.shop.email.trim();
            if (this.activeCms.shop.invoice_recipient_email) {
                // bcc = `${this.activeCms.shop.name || this.activeCms.name} <${this.activeCms.shop.purchase_confirmation_recipient_email}>`.trim();
                bcc = this.activeCms.shop.invoice_recipient_email.trim();
            }

            const invoice = {
                name: this.$t('Invoice PDF'),
                filename: `${this.form.id}-invoice.pdf`, // TODO: change as soon as the filename becomes configurable
                pagination: { total: 1, current: 1 },
                getUrl: () => PurchaseApi.invoiceRenderingUrl(this.form.id, 'pdf'),
            }

            const payload = {
                subject: `Ihre Rechnung ${this.invoice_nr}`.trim(), // TODO: ändern sobald einstellungen dafür da sind
                sender,
                recipients: [purchaser],
                ccs: [],
                bccs: [bcc],
                attachments: [invoice],
            };
            this.$set(this.modal, 'data', payload);

            this.modal.type = 'email-preview';
            this.modal.context = 'invoice-email';
            this.modal.title = this.$t('Email preview');
            this.modal.visibility = true;
            this.modal.loading = true;
            this.modal.submit = this.$t('Send email now')

            this.$nextTick(() => {
                const iframe = this.$refs['preview-iframe']
                PurchaseApi.renderInvoice(this.form.id, 'email')
                    .then(({ data }) => {
                        payload.subject = data.subject;
                        iframe.contentWindow.document.open();
                        iframe.contentWindow.document.write(data.document);
                        iframe.contentWindow.document.close();
                    })
                    .catch(() => {
                        this.modal.submit = false;
                        this.modal.error = true;
                        this.$notify.error({
                            title: this.$t('An error occurred!'),
                            message: this.$t('Invoice email preview could not be rendered'),
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000,
                        })
                    })
                    .finally(() => {
                        this.modal.loading = false;
                        // this.refreshAuthentification();
                    })
            })
        },
        showCreditNoteEmailDialog(cancellation) {
            let sender = this.activeCms.name.trim();
            if (this.activeCms.smtp) sender = `${this.activeCms.smtp.name || this.activeCms.name} <${this.activeCms.smtp.username}>`.trim();
            const purchaser = `${this.form.purchaser.first_name} ${this.form.purchaser.last_name} <${this.form.purchaser.email}>`.trim();
            let bcc = `${this.activeCms.owner.user.name} <${this.activeCms.owner.user.email}>`.trim();
            // if (this.activeCms.shop.invoice_recipient_email) {
            //     // bcc = `${this.activeCms.shop.name || this.activeCms.name} <${this.activeCms.shop.purchase_confirmation_recipient_email}>`.trim();
            //     bcc = this.activeCms.shop.invoice_recipient_email.trim();
            // }

            const creditNote = {
                name: this.$t('Credit Note PDF'),
                filename: `${this.form.id}-credit-note.pdf`, // TODO: change as soon as the filename becomes configurable
                pagination: { total: 1, current: 1 },
                getUrl: () => PurchaseApi.creditNoteRenderingUrl(cancellation.id, 'pdf'),
            }

            const payload = {
                subject: 'Gutschrift zu Ihrer Bestellung', // TODO: ändern sobald einstellungen dafür da sind
                sender,
                recipients: [purchaser],
                ccs: [],
                bccs: [bcc],
                attachments: [creditNote],
            };
            this.$set(this.modal, 'data', payload);

            this.modal.type = 'email-preview';
            this.modal.context = 'credit-note-email';
            this.modal.title = this.$t('Email preview');
            this.modal.visibility = true;
            this.modal.loading = true;
            this.modal.submit = this.$t('Send email now')

            this.modal.data.cancellation = cancellation;

            this.$nextTick(() => {
                const iframe = this.$refs['preview-iframe']
                PurchaseApi.renderCreditNote(cancellation.id, 'email')
                    .then(({ data }) => {
                        payload.subject = data.subject;
                        iframe.contentWindow.document.open();
                        iframe.contentWindow.document.write(data.document);
                        iframe.contentWindow.document.close();
                    })
                    .catch(() => {
                        this.modal.submit = false;
                        this.modal.error = true;
                        this.$notify.error({
                            title: this.$t('An error occurred!'),
                            message: this.$t('Credit note email preview could not be rendered'),
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000,
                        })
                    })
                    .finally(() => {
                        this.modal.loading = false;
                        // this.refreshAuthentification();
                    })
            })
        },
        showPurchaseConfirmationEmailDialog() {
            let sender = this.activeCms.name.trim();
            if (this.activeCms.smtp) sender = `${this.activeCms.smtp.name || this.activeCms.name} <${this.activeCms.smtp.username}>`.trim();
            const purchaser = `${this.form.purchaser.first_name} ${this.form.purchaser.last_name} <${this.form.purchaser.email}>`.trim();
            let bcc = `${this.activeCms.owner.user.name} <${this.activeCms.owner.user.email}>`.trim();
            if (this.activeCms.shop.email) bcc = this.activeCms.shop.email.trim();
            if (this.activeCms.shop.purchase_confirmation_recipient_email) {
                // bcc = `${this.activeCms.shop.name || this.activeCms.name} <${this.activeCms.shop.purchase_confirmation_recipient_email}>`.trim();
                bcc = this.activeCms.shop.purchase_confirmation_recipient_email.trim();
            }

            const confirmation = {
                name: this.$t('Purchase confirmation PDF'),
                filename: `${this.form.id}-purchase-confirmation.pdf`, // TODO: change as soon as the filename becomes configurable
                pagination: { total: 1, current: 1 },
                getUrl: () => PurchaseApi.confirmationRenderingUrl(this.form.id, 'pdf'),
            }

            let attachments = []
            attachments.push(confirmation)

            if (this.form.soldCoupons && this.form.soldCoupons.length) {
                this.form.soldCoupons.forEach((coupon, i) => {
                    let name = this.$t('Coupon PDF')
                    if (this.form.soldCoupons.length > 1) name = this.$t(`{number}. Coupon PDF`, { number: i + 1 })

                    const soldCoupon = {
                        name,
                        filename: `${coupon.id}-coupon.pdf`, // TODO: change as soon as the filename becomes configurable
                        pagination: { total: 1, current: 1 },
                        getUrl: () => PurchaseApi.couponRenderingUrl(coupon.id, 'letter'),
                        // getUrl: () => {
                        //     if (coupon.letter) {
                        //         const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PRIVATE_STORAGE_ROUTE}`, '/')
                        //         let table = 'files'
                        //
                        //         const receipt = this.receipt;
                        //         const token = AuthApi.getToken()
                        //         return `${storageRoute}/${table}/${coupon.letter.id}/${coupon.letter.name}?token=${token}`
                        //     }
                        // },
                    }
                    attachments.push(soldCoupon)
                })
            }

            const payload = {
                subject: 'Ihre Bestellung', // TODO: ändern sobald einstellungen dafür da sind
                sender,
                recipients: [purchaser],
                ccs: [],
                bccs: [bcc],
                attachments,
            };
            this.$set(this.modal, 'data', payload);

            this.modal.type = 'email-preview';
            this.modal.context = 'purchase-confirmation-email';
            this.modal.title = this.$t('Email preview');
            this.modal.visibility = true;
            this.modal.loading = true;
            this.modal.submit = this.$t('Send email now')

            this.$nextTick(() => {
                const iframe = this.$refs['preview-iframe']
                PurchaseApi.renderConfirmation(this.form.id, 'email')
                    .then(({ data }) => {
                        payload.subject = data.subject;
                        iframe.contentWindow.document.open();
                        iframe.contentWindow.document.write(data.document);
                        iframe.contentWindow.document.close();
                    })
                    .catch(() => {
                        this.modal.submit = false;
                        this.modal.error = true;
                        this.$notify.error({
                            title: this.$t('An error occurred!'),
                            message: this.$t('Confirmation email preview could not be rendered'),
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000,
                        })
                    })
                    .finally(() => {
                        this.modal.loading = false;
                        // this.refreshAuthentification();
                    })
            })
        },
        showShippingConfirmationEmailDialog(id) {
            this.currentPackageId = id

            let sender = this.activeCms.name.trim();
            if (this.activeCms.smtp) sender = `${this.activeCms.smtp.name || this.activeCms.name} <${this.activeCms.smtp.username}>`.trim();
            const purchaser = `${this.form.purchaser.first_name} ${this.form.purchaser.last_name} <${this.form.purchaser.email}>`.trim();
            let bcc = `${this.activeCms.owner.user.name} <${this.activeCms.owner.user.email}>`.trim();
            if (this.activeCms.shop.email) bcc = this.activeCms.shop.email.trim();
            if (this.activeCms.shop.purchase_confirmation_recipient_email) {
                bcc = this.activeCms.shop.purchase_confirmation_recipient_email.trim();
            }

            this.$set(this.modal, 'data', {
                subject: 'Versandbestätigung',
                sender,
                recipients: [purchaser],
                ccs: [],
                bccs: [bcc]
            });

            this.modal.type = 'email-preview';
            this.modal.context = 'shipping-confirmation-email';
            this.modal.title = this.$t('Email preview');
            this.modal.visibility = true;
            this.modal.loading = true;
            this.modal.submit = this.$t('Send email now')

            this.$nextTick(() => {
                const iframe = this.$refs['preview-iframe']
                PurchaseApi.renderShippingPackageSent(id, 'email')
                    .then(({ data }) => {
                        iframe.contentWindow.document.open();
                        iframe.contentWindow.document.write(data);
                        iframe.contentWindow.document.close();
                    })
                    .catch(() => {
                        this.modal.submit = false;
                        this.modal.error = true;
                        this.$notify.error({
                            title: this.$t('An error occurred!'),
                            message: this.$t('Shipping confirmation email preview could not be rendered'),
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000,
                        })
                    })
                    .finally(() => {
                        this.modal.loading = false;
                    })
            })
        },
        showInvoicePdfDialog() {
            this.$set(this.modal, 'data', {
                preview: {
                    name: this.$t('Invoice PDF'),
                    filename: `${this.form.id}-invoice.pdf`, // TODO: change as soon as the filename becomes configurable
                    pagination: { total: 1, current: 1 },
                    getUrl: () => PurchaseApi.invoiceRenderingUrl(this.form.id, 'pdf'),
                }
            });

            this.modal.type = 'pdf-preview';
            this.modal.context = 'invoice-pdf';
            this.modal.title = this.$t('Invoice PDF');
            this.modal.visibility = true;
            this.modal.loading = true;
            this.modal.submit = false;
        },
        showCreditNotePdfDialog(cancellation) {
            this.$set(this.modal, 'data', {
                preview: {
                    name: this.$t('Credit Note PDF'),
                    filename: `${cancellation.id}-credit-note.pdf`, // TODO: change as soon as the filename becomes configurable
                    pagination: { total: 1, current: 1 },
                    getUrl: () => PurchaseApi.creditNoteRenderingUrl(cancellation.id, 'pdf'),
                }
            });
            this.modal.type = 'pdf-preview';
            this.modal.context = 'credit-note-pdf';
            this.modal.title = this.$t('Credit Note PDF');
            this.modal.visibility = true;
            this.modal.loading = true;
            this.modal.submit = false;
        },
        showCancellationReceiptPdfDialog(cancellation) {
            var tillRoll = cancellation.latestTillRoll;
            if (!tillRoll) return;
            this.$set(this.modal, 'data', {
                preview: {
                    name: this.$t('Cancellation Receipt'),
                    filename: tillRoll.name,
                    pagination: { total: 1, current: 1 },
                    getUrl: function() {
                        var storageRoute = _.trim(process.env.VUE_APP_API_ENDPOINT + process.env.VUE_APP_API_PRIVATE_STORAGE_ROUTE, '/');
                        var token = AuthApi.getToken();
                        return storageRoute + '/files/' + tillRoll.id + '/' + tillRoll.name + '?token=' + token;
                    },
                }
            });
            this.modal.type = 'pdf-preview';
            this.modal.context = 'receipt';
            this.modal.title = this.$t('Cancellation Receipt');
            this.modal.visibility = true;
            this.modal.loading = true;
            this.modal.submit = false;
        },
        showPurchaseConfirmationPdfDialog() {
            this.$set(this.modal, 'data', {
                preview: {
                    name: this.$t('Purchase confirmation PDF'),
                    filename: `${this.form.id}-purchase-confirmation.pdf`, // TODO: change as soon as the filename becomes configurable
                    pagination: { total: 1, current: 1 },
                    getUrl: () => PurchaseApi.confirmationRenderingUrl(this.form.id, 'pdf'),
                }
            });

            this.modal.type = 'pdf-preview';
            this.modal.context = 'purchase-confirmation-pdf';
            this.modal.title = this.$t('Purchase confirmation PDF');
            this.modal.visibility = true;
            this.modal.loading = true;
            this.modal.submit = false;
        },
        showDeliveryNotePdfDialog() {
            this.$set(this.modal, 'data', {
                preview: {
                    name: this.$t('Delivery note PDF'),
                    filename: `${this.form.id}-delivery-note.pdf`, // TODO: change as soon as the filename becomes configurable
                    pagination: { total: 1, current: 1 },
                    getUrl: () => PurchaseApi.deliveryNoteRenderingUrl(this.form.id),
                }
            });

            this.modal.type = 'pdf-preview';
            this.modal.context = 'delivery-note';
            this.modal.title = this.$t('Delivery note PDF');
            this.modal.visibility = true;
            this.modal.loading = true;
            this.modal.submit = false;
        },
        showPackingListPdfDialog() {
            this.$set(this.modal, 'data', {
                preview: {
                    name: this.$t('Packing slip PDF'),
                    filename: `${this.form.id}-packing-list.pdf`, // TODO: change as soon as the filename becomes configurable
                    pagination: { total: 1, current: 1 },
                    getUrl: () => PurchaseApi.packingListRenderingUrl(this.form.id),
                }
            });

            this.modal.type = 'pdf-preview';
            this.modal.context = 'packing-list';
            this.modal.title = this.$t('Packing slip PDF');
            this.modal.visibility = true;
            this.modal.loading = true;
            this.modal.submit = false;
        },
        showShippingPackageSlipPdfDialog(shippingPackage) {
            this.$set(this.modal, 'data', {
                preview: {
                    name: this.$t('Packing slip PDF'),
                    filename: `${this.form.id}-${shippingPackage.id}-packing-list.pdf`, // TODO: change as soon as the filename becomes configurable
                    pagination: { total: 1, current: 1 },
                    getUrl: () => PurchaseApi.shippingPackageSlipRenderingUrl(shippingPackage.id),
                }
            });

            this.modal.type = 'pdf-preview';
            this.modal.context = 'packing-list';
            this.modal.title = this.$t('Packing slip PDF');
            this.modal.visibility = true;
            this.modal.loading = true;
            this.modal.submit = false;
        },
        showReceiptPdfDialog() {
            this.$set(this.modal, 'data', {
                preview: {
                    name: this.$t('Receipt PDF'),
                    filename: `${this.form.id}-receipt.pdf`,
                    pagination: { total: 1, current: 1 },
                    getUrl: () => {
                        const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PRIVATE_STORAGE_ROUTE}`, '/')
                        let table = 'files'

                        const receipt = this.receipt;
                        const token = AuthApi.getToken()
                        return `${storageRoute}/${table}/${receipt.id}/${receipt.name}?token=${token}`
                    },
                }
            });

            this.modal.type = 'pdf-preview';
            this.modal.context = 'receipt';
            this.modal.title = this.$t('Receipt PDF');
            this.modal.visibility = true;
            this.modal.loading = true;
            this.modal.submit = false;
        },
        renderReceiptPDF() {
            this.rendering.receipt = true;
            axios.get(PurchaseApi.receiptRenderingUrl(this.form.id, 'store'))
                .then(({ data }) => {
                    this.setLatestReceipt(data)
                    this.showReceiptPdfDialog()
                })
                .catch(error => {
                    console.error(error)
                    this.rendering.receipt = false;
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Receipt could not be rendered'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                })
        },
        previewModalAttachment(attachment) {
            this.$set(this.modal.data, 'preview', attachment);
            this.$set(this.modal.data.preview, 'loading', true);
            this.$set(this.modal.data.preview, 'pagination', { total: 1, current: 1 });
            this.modal.title = attachment.name;
        },
        renderLatestConfirmationPdf() {
            // this.$set(this.modal, 'data', {
            //     // ,,,
            // });

            // this.modal.type = 'purchase-confirmation-pdf';
            // this.modal.title = this.$t('Purchase confirmation PDF');
            // this.modal.visibility = true;
            // this.modal.loading = true;
            // this.modal.submit = false;
        },
        renderLatestConfirmationEmail() {
            // TODO
        },
        // eslint-disable-next-line
        toggleStatus(key) {
            let status
            if (this.form.status && this.form.status.key === key && this.history.status) {
                status = this.history.status;

                this.notify = false
                this.statusChangeNotification = undefined
            } else {
                switch (key) {
                    case 'payed':
                        status = { key: 'payed', name: this.$t('Payed') }
                        break;

                    case 'shipped':
                    case 'closed':
                        status = this.options.status.items.find(el => el.key === key);
                        break;
                }

                if (status) {
                    this.notify = this.shopPurchaseStore.notifiesPurchaserByDefault
                    this.statusChangeNotification = {
                        status,
                        commentary: '',
                        shipping_method_service: '',
                        shipping_method_name: '',
                        tracking_code: '',
                    }
                }
            }

            if (status) {
                this.setStatus(status);
            }

            // this.sendEmailDialog.status = key
            // this.sendEmailDialog.visibility = true
            // // this.openStatusEmailDialog()
        },
        toggleIndicator(indicator) {
            const indicators = _.cloneDeep(this.indicators);
            const i = indicators.findIndex(el => el.id === indicator.id)
            if (i >= 0) {
                indicators.splice(i, 1);
            } else {
                indicators.push(indicator);
            }
            this.setIndicators(indicators);
        },
        closeModal() {
            this.modal.visibility = false;
        },
        // A PDF preview is as wide as a whole A4 page needs at this window
        // height; a receipt keeps its till-roll width, a mail its own.
        fitDocumentDrawer() {
            if (this.modal.type !== 'pdf-preview' || this.modal.context === 'receipt') return;
            this.modal.size = a4DrawerSizeEstimate();
            this.$nextTick(() => {
                this.modal.size = a4DrawerSize(this.$el.querySelector('.el-drawer__wrapper.email')) || this.modal.size;
            });
        },
        resetModal() {
            this.modal = {
                visibility: false,
                type: 'email-preview',
                context: undefined,
                size: '40%',
                title: this.$t('Preview'),
                loading: false,
                saving: false,
                submit: false,
                error: false,
            };

            const iframe = this.$refs['preview-iframe']
            if (iframe) {
                iframe.contentWindow.document.open();
                iframe.contentWindow.document.write('');
                iframe.contentWindow.document.close();
            }
        },
        submitModal() {
            this.modal.saving = true;
            switch (this.modal.context) {
                case 'invoice-email':
                    this.sendInvoice(this.form)
                        .then(() => {
                            this.closeModal();
                            this.$notify.success({
                                title: this.$t('Invoice email sent successfully!'),
                                iconClass: 'fas el-icon-fa-check',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });
                        })
                        .catch(error => {
                            // eslint-disable-next-line
                            console.error(error)
                            this.$notify.error({
                                title: this.$t('An error occurred!'),
                                message: this.$t('Invoice email could not be sent'),
                                iconClass: 'fas el-icon-fa-times',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000,
                            })
                        })
                        .finally(() => {
                            this.modal.saving = false
                        })
                    break;

                case 'purchase-confirmation-email':
                    this.sendConfirmation(this.form)
                        .then(() => {
                            this.closeModal();
                            this.$notify.success({
                                title: this.$t('Confirmation email sent successfully!'),
                                iconClass: 'fas el-icon-fa-check',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });
                        })
                        .catch(error => {
                            // eslint-disable-next-line
                            console.error(error)
                            this.$notify.error({
                                title: this.$t('An error occurred!'),
                                message: this.$t('Confirmation email could not be sent'),
                                iconClass: 'fas el-icon-fa-times',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000,
                            })
                        })
                        .finally(() => {
                            this.modal.saving = false
                        })
                    break;

                case 'credit-note-email':
                    this.sendCreditNote(this.modal.data.cancellation)
                        .then(() => {
                            this.fetchPurchase(this.form.id)
                                .finally(() => {
                                    this.modal.saving = false
                                    this.closeModal();
                                    this.$notify.success({
                                        title: this.$t('Credit note email sent successfully!'),
                                        iconClass: 'fas el-icon-fa-check',
                                        position: 'bottom-left',
                                        customClass: 'dark',
                                        duration: 8000
                                    });
                                })
                        })
                        .catch(error => {
                            this.modal.saving = false
                            // eslint-disable-next-line
                            console.error(error)
                            this.$notify.error({
                                title: this.$t('An error occurred!'),
                                message: this.$t('Credit note email could not be sent'),
                                iconClass: 'fas el-icon-fa-times',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000,
                            })
                        })
                    break;

                case 'return-received-email':
                case 'return-status-changed-email':
                    PurchaseApi.resendReturnEmail(this.modal.data.cancellation.id, this.modal.data.scope)
                        .then(() => {
                            this.fetchPurchase(this.form.id)
                                .finally(() => {
                                    this.modal.saving = false;
                                    this.closeModal();
                                    this.$notify.success({
                                        title: this.$t('Email sent'),
                                        iconClass: 'fas el-icon-fa-check',
                                        position: 'bottom-left',
                                        customClass: 'dark',
                                        duration: 8000,
                                    });
                                });
                        })
                        .catch(error => {
                            this.modal.saving = false;
                            console.error(error);
                            this.$notify.error({
                                title: this.$t('An error occurred!'),
                                message: this.$t('Email could not be sent'),
                                iconClass: 'fas el-icon-fa-times',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000,
                            });
                        });
                    break;

                case 'shipping-confirmation-email':
                    this.sendShippingPackageSent(this.currentPackageId)
                        .then(() => {
                            this.closeModal();
                            this.$notify.success({
                                title: this.$t('Shipping email sent successfully!'),
                                iconClass: 'fas el-icon-fa-check',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });
                            this.currentPackageId = null
                        })
                        .catch(error => {
                            // eslint-disable-next-line
                            console.error(error)
                            this.$notify.error({
                                title: this.$t('An error occurred!'),
                                message: this.$t('shipping email could not be sent'),
                                iconClass: 'fas el-icon-fa-times',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000,
                            })
                        })
                        .finally(() => {
                            this.modal.saving = false
                        })
                    break;
            }
        },
        resetPreviewModal() {
            delete this.modal.data.preview;
            this.modal.title = this.$t('Email preview');
        },
        async printPreview() {
            // NOTE: does not work
            // this.$refs['pdf-preview'].print();
            await ensureFreshToken();
            const url = this.modal.data.preview.getUrl();
            printJS({ printable: url });
        },
        printLabel() {
            // print()
            console.log("printLabel")
            // this.PrintImage(this.cSrc)
            const printable = this.modal.labelSrc
            console.log(printable)
            printJS({
                printable,
                type: 'image',
                onLoadingEnd: () => {
                    // Don't close modal here - wait for print dialog
                },
                onError: () => {
                    this.modal.loading = false
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Could not print the shipping package slip!'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                },
                onPrintDialogClose: () => {
                    this.modal.loading = false
                    this.closeModal()
                }
            })
        },
        async downloadPreview() {
            await ensureFreshToken();
            const element = document.createElement('a');
            const url = this.modal.data.preview.getUrl();
            element.setAttribute('href', `${url}&download`);
            // NOTE: does not work
            // element.setAttribute('download', this.modal.data.preview.filename);

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();

            document.body.removeChild(element);
        },
        async previewLoaded() {
            if (this.form.id && ['invoice-email', 'invoice-pdf'].includes(this.modal.context)) {
                await apolloClient.clearStore();
                this.fetchPurchase(this.form.id)
            }

            // this.refreshAuthentification();
            if (this.modal.data && this.modal.data.preview) {
                switch (this.modal.type) {
                    case 'pdf-preview':
                        setTimeout(() => {
                            this.$set(this.modal, 'loading', false);
                        }, 150)
                        break;

                    default:
                    case 'email-preview':
                        setTimeout(() => {
                            this.$set(this.modal.data.preview, 'loading', false);
                        }, 150)
                        break;
                }
            }
        },
        previewError(error) {
            let message;
            switch (error.name) {
                case 'MissingPDFException':
                    message = {
                        title: this.$t('An error occurred!'),
                        message: this.$t('Missing PDF'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    }
                    break;

                default:
                    message = {
                        title: this.$t('An error occurred!'),
                        message: this.$t('Preview could not be rendered'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    }
            }

            if (this.modal.data && this.modal.data.preview) {
                switch (this.modal.type) {
                    case 'pdf-preview':
                        setTimeout(() => {
                            this.closeModal()
                        }, 300)
                        break;

                    default:
                    case 'email-preview':
                        this.resetPreviewModal()
                        break;
                }
            }

            this.$notify.error(message)
        },
        updatePreviewPagination(key, value) {
            if (this.modal.data && this.modal.data.preview) {
                let timeout = 0

                if (key === 'current') {
                    if (this.$refs.preview.scrollTop) {
                        timeout = 200
                    }

                    this.$refs.preview.scroll({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    })
                }

                setTimeout(() => {
                    this.$set(this.modal.data.preview.pagination, key, value);
                }, timeout);
            }
        },
        getTailClass(i) {
            var current = _.get(this.logs, i)
            var next = _.get(this.logs, i + 1)
            if (!next) return current.timestamp ? 'success' : undefined

            // Only connect items that have actually happened (have a timestamp)
            if (current.timestamp && next.timestamp) return 'success'
        },
        async openShipmentLabel(shippingPackage) {
            const token = await ensureFreshToken()

            const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PRIVATE_STORAGE_ROUTE}`, '/')

            // let url = `http://127.0.0.1:3000/storage/private/files/${shippingPackage.shipmentLabel.id}/${shippingPackage.shipmentLabel.name}?token=${token}`
            let url = `${storageRoute}/files/${shippingPackage.shipmentLabel.id}/${shippingPackage.shipmentLabel.name}?token=${token}`

            this.modal.labelSrc = url

            this.modal.type = 'label-preview';
            this.modal.title = this.$t('Shipping label');
            this.modal.visibility = true;
            this.modal.submit = false;
        },
        ImageToPrint(source) {
            return "<html><head><scri" + "pt>function step1(){\n" +
                "setTimeout('step2()', 10);}\n" +
                "function step2(){window.print();window.close()}\n" +
                "</scri" + "pt></head><body onload='step1()'>\n" +
                "<img src='" + source + "' /></body></html>";
        },
        PrintImage(source) {
            var Pagelink = "about:blank";
            var pwa = window.open(Pagelink, "_new");
            pwa.document.open();
            pwa.document.write(this.ImageToPrint(source));
            pwa.document.close();
        },
        getUpsReturnLabel(shippingPackage) {
            console.log(JSON.stringify(shippingPackage))
            const body = {
                upsAccessToken: JSON.parse(localStorage.getItem("upstoken")).access_token,
                upsRequest: {
                    LabelRecoveryRequest: {
                        Request: {
                            RequestOption: 'Non_Validate',
                            SubVersion: '1903',
                            TransactionReference: {
                                CustomerContext: '',
                                TransactionIdentifier: ''
                            }
                        },
                        LabelSpecification: {
                            HTTPUserAgent: "Mozilla/4.5",
                            LabelImageFormat: {
                                Code: "ZPL"
                            },
                            LabelStockSize: {
                                Height: "6",
                                Width: "4"
                            }
                        },
                        Translate: {
                            LanguageCode: "eng",
                            DialectCode: "US",
                            Code: "01"
                        },
                        LabelDelivery: {
                            LabelLinkIndicator: "",
                            ResendEMailIndicator: "",
                            EMailMessage: {
                                EMailAddress: ""
                            }
                        },
                        TrackingNumber: "1Z12345E8791315509" //fixed TrackingNumber for testing, other dynamically created TrackingNumbers (1XXX...) in test mode dont work
                        // TrackingNumber: shippingPackage.tracking_nr
                    }
                }
            };
            //createReturnLabel
            if (this.upsRefreshNeeded()) {
                this.loading = true
                UPSApi.refreshToken().then((data) => {
                    this.createReturnLabel(body);
                }).catch((err) => console.log(err)).finally(() => this.loading = false)
            }
            else {
                this.createReturnLabel(body);
            }
        },
        createReturnLabel(body) {
            this.loading = true
            UPSApi.createReturnLabel(body).then((data) => {
                this.showPDF(data.LabelRecoveryResponse.LabelResults.Receipt.Image.GraphicImage)
            }).catch((err) => console.log(err)).finally(() => this.loading = false)
        },
        showPDF(encodedString) {
            printJS({
                printable: encodedString,
                type: 'pdf',
                base64: true
            });
        },
        // resetEmailModal() {
        //     this.sendEmailDialog = {
        //         visibility: false,
        //         status: 'payed',
        //         commentary: '',
        //         shipping_method_service: '',
        //         shipping_method_name: '',
        //         tracking_code: '',
        //         notify: true,
        //         loading: false,
        //     }
        // },
        // async sendStatusEmail() {
        //     // const payload = {
        //     //     id: parseInt(this.form.id),
        //     //     status: this.$t(this.sendEmailDialog.status),
        //     //     commentary: this.sendEmailDialog.commentary,
        //     //     shippingService: this.sendEmailDialog.shipping_method_service,
        //     //     shippingServiceName: this.sendEmailDialog.shipping_method_name,
        //     //     trackingCode: this.sendEmailDialog.tracking_code,
        //     // }
        //     //
        //     // if (this.sendEmailDialog.notify) {
        //     //     this.sendEmailDialog.loading = true
        //     //     await this.storeSendStatusEmail(payload).then(() => {
        //     //         this.sendEmailDialog.visibility = false
        //     //
        //     //         this.$notify.success({
        //     //             title: this.$t('Email sent successfully!'),
        //     //             iconClass: 'fas el-icon-fa-check',
        //     //             position: 'bottom-left',
        //     //             customClass: 'dark',
        //     //             duration: 8000
        //     //         });
        //     //     })
        //     //
        //     //     this.sendEmailDialog.loading = false
        //     // }
        //
        //     if (this.sendEmailDialog.notify) {
        //         const statusChangeNotification = {
        //             status: this.$t(this.sendEmailDialog.status),
        //             commentary: this.sendEmailDialog.commentary,
        //             shipping_method_service: this.sendEmailDialog.shipping_method_service,
        //             shipping_method_name: this.sendEmailDialog.shipping_method_name,
        //             tracking_code: this.sendEmailDialog.tracking_code,
        //             notify: this.sendEmailDialog.notify,
        //         }
        //     }
        //
        //     this.$root.$emit('save');
        // },
        setStatus(value) {
            this.shopPurchaseStore.setFormStatus(value);
        },
        setIndicators(value) {
            this.shopPurchaseStore.setFormIndicators(value);
        },
        setLatestReceipt(value) {
            this.shopPurchaseStore.setFormLatestReceipt(value);
        },
        setNotify(value) {
            this.shopPurchaseStore.setFormNotify(value);
        },
        setStatusChangeNotification(value) {
            this.shopPurchaseStore.setFormStatusChangeNotification(value);
        },
        setStatusChangeNotificationShippingMethodService(value) {
            this.shopPurchaseStore.setFormStatusChangeNotificationShippingMethodService(value);
        },
        setStatusChangeNotificationShippingMethodName(value) {
            this.shopPurchaseStore.setFormStatusChangeNotificationShippingMethodName(value);
        },
        setStatusChangeNotificationTrackingCode(value) {
            this.shopPurchaseStore.setFormStatusChangeNotificationTrackingCode(value);
        },
        setStatusChangeNotificationCommentary(value) {
            this.shopPurchaseStore.setFormStatusChangeNotificationCommentary(value);
        },
        refreshAuthentification(name) {
            return useAuthStore().refresh(name);
        },
        sendInvoice(payload) {
            return this.shopPurchaseStore.sendInvoice(payload);
        },
        sendConfirmation(payload) {
            return this.shopPurchaseStore.sendConfirmation(payload);
        },
        sendCreditNote(payload) {
            return this.shopPurchaseStore.sendCreditNote(payload);
        },
        sendShippingPackageSent(payload) {
            return this.shopPurchaseStore.sendShippingPackageSent(payload);
        },
        // Forward fetchPolicy so callers can bust the Apollo cache when a
        // mutation just changed the purchase state. Without this, every
        // refresh after approve / mark-received / etc. came back as the
        // cached pre-mutation snapshot and the summary panel kept showing
        // the stale totals.
        fetchPurchase(id, fetchPolicy = 'cache-first') {
            return this.shopPurchaseStore.fetchPurchase(id, fetchPolicy);
        },
    }
};
</script>

<style lang="sass" scoped>
// Card-style summary panel — matches the Documents column's .artifact-card
// aesthetic (background, border, radius, padding) so the left and right
// columns read as a single visual language. Dropped the legacy
// .bordered-table / .panel classes from the markup because their global
// rules override our local ones at the same specificity level.
.summary.summary-card
    background: var(--background-base, #fafafa)
    border: 1px solid var(--border-color, #ebeef5)
    border-radius: 6px
    padding: 4px
    box-shadow: none
    width: 100%
    // CSS grid items stretch vertically by default. Without this, the
    // summary table inflates to match the tallest column (Documents),
    // exploding row heights from ~30px to ~75px.
    align-self: start
    border-spacing: 0
    > tbody > tr,
    > tr
        > td
            padding: 4px 12px
            font-size: 13px
            border-bottom: 0
            vertical-align: middle
            line-height: 1.4
        > td:first-child
            color: var(--color-text-secondary, #606266)
            font-weight: 400
        > td.col-right
            color: var(--color-text-regular, #303133)
            text-align: right
            font-weight: 500
        // Section dividers — match the card border color so they read
        // as subtle grouping lines, not bold horizontal rules.
        > td hr
            border: 0
            border-top: 1px solid var(--border-color, #ebeef5)
            margin: 4px 0
    // Grand total: visually anchor the bottom of the card.
    > tbody > tr:last-of-type > td,
    > tr:last-of-type > td
        padding-top: 10px
        padding-bottom: 8px
        font-size: 14px
        b
            font-size: 15px
            color: var(--color-text-primary, #1f2d3d)
    // The .show-details-button row hosts an el-button — strip its td
    // padding so the button sits flush with the table edge.
    .show-details-button > td
        padding: 2px 8px

// Same rhythm as Documents.vue's .shipping-block / .cancellation-block —
// one dispatched mail per row, separated by a hairline.
.status-change-block
    display: flex
    flex-direction: column
    gap: 8px
    border-top: 1px solid var(--border-color, #ebeef5)
    padding: 8px 0
    &:first-of-type
        border-top: 0
        padding-top: 4px

.status-change-block__head
    display: flex
    align-items: center
    flex-wrap: wrap
    gap: 8px

.status-change-block__title
    flex: 1
    font-size: 13px

.status-change-block__date
    color: var(--color-text-secondary, #606266)
    font-size: 12px

// The toggle sits below the history, separated by the same hairline the
// rows use — but only when there is history above it to separate from.
.status-change-block + .status-change-form
    border-top: 1px solid var(--border-color, #ebeef5)
    padding-top: 12px
    margin-top: 8px

.status-change-notification
    margin-top: 12px

.grid
    display: grid
    grid-template-columns: auto max-content
    grid-template-rows: auto auto
    gap: 2rem
    .timeline
        grid-column: 2
        grid-row: 1
        // .el-timeline
        //     padding-left: 0 !important
    .details
        margin-left: 0 !important
        grid-column: 1 / span 2
        grid-row: 2
        // The status-change card is a sibling of <Documents>, so this column
        // owns the same 8px card rhythm .documents applies internally.
        display: flex
        flex-direction: column
        gap: 8px
    +res(lg)
        grid-template-columns: 340px 1fr max-content
        grid-template-rows: auto
        .timeline
            grid-column: 3
            grid-row: 1
        .details
            grid-column: 2
            grid-row: 1

.timeline
    min-width: 180px
    max-width: 400px
    margin-top: 0
    display: flex
    align-items: center
    ul.el-timeline
        padding-left: 18px
        > li.el-timeline-item:last-of-type
            padding-bottom: 0
    +res(lg)
        display: block
        ul.el-timeline
            padding-left: 2rem

.el-timeline-item__content
    h4
        margin: 0
        font-weight: normal
    p
        margin: 0
        margin-top: 8px
button.el-timeline-item__node
    border: 0
    z-index: 1
    cursor: pointer
    outline: none
    box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.3)
    // background-color: #efefef
    transition: background-color .15s ease
    &:hover
        background: $--color-success
    &.el-timeline-item__node--active
        background: lighten($--color-success, 40%)
        box-shadow: 0 0 0px 0.125rem $--color-success
.send,
.resend
    a + a
        margin-left: 1rem

.purchase-form-main > *
    opacity: 0
    // transition: opacity .3s ease

.purchase-form-main.loaded > *
    opacity: 1

.purchase-form-main
    .el-drawer__wrapper.email,
    .el-drawer__wrapper.preview
        ::v-deep .el-drawer
            min-width: 600px
            max-width: 90%
            .el-form
                display: flex
                flex-direction: column
                .body
                    position: relative
                    flex-grow: 1
                    width: 100%
            iframe,
            .preview
                // width: 100%
                // flex-grow: 1
                // max-height: calc(100vh - 135px)
                position: absolute
                left: 0
                top: 0
                width: 100%
                height: 100%
                max-width: 100%
                max-height: 100%
                overflow: auto
            .pill
                // padding: 2px 6px
                // background: #e2e2e2
                // margin: 2px
                // display: inline-block
                // border-radius: 3px
                &:not(:last-child):after
                    content: ', '
                    margin-right: 2px
            .from-to b + span.pill
                margin-left: 4px
            .meta
                padding: 20px
                padding-top: 0
                font-size: 0.8rem
                display: grid
                grid-template-rows: auto auto
                grid-template-columns: auto auto
                .subject
                    grid-row: 2
                    margin-top: 1rem
                    b + span
                        margin-left: 4px
                .attachments
                    grid-column: 2
                    text-align: right
                    display: flex
                    flex-direction: column
                    align-items: flex-end
                    /* justify-content: flex-end */
                    ul
                        // display: flex
                        // flex-wrap: wrap
                        // gap: 0.5rem
                        list-style: none
                        padding: 0
                        margin: 0
    .el-drawer__wrapper.preview
        ::v-deep .el-drawer
            min-width: 560px
            max-width: calc(90% - 40px)
    .el-drawer__wrapper.receipt
        ::v-deep .el-drawer
            min-width: 320px
            max-width: 380px
    .drawer-footer
        align-items: center

    .preview
        padding: 2rem 20px
        display: flex
        align-items: center
        justify-content: center
        & > span
            width: 100%
            flex-grow: 1
            margin: auto 0
        &.loaded
            background: #babfc3
            & > span
                box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.3)
// .summary-divider
//     td
//         padding: 0 !important
//     hr
//         border: 1px solid #ffffff
//         margin: 0
.show-details-button
    td
        padding-top: 0 !important
        margin-top: -1rem
tr.no-margin-bottom
    td
        padding-bottom: 0 !important
    hr
        margin-bottom: 0

.refund-status
    margin-right: 1rem
    color: $--color-success
    i
        margin-right: 2px
    &.refund-failed
        color: $--color-warning

.cancellation-row-header
    display: flex
    align-items: center
    flex-wrap: wrap
    gap: 1rem

.status-badge
    display: inline-block
    padding: 2px 8px
    border-radius: 10px
    font-size: 0.75rem
    font-weight: 600
    line-height: 1.4
    text-transform: uppercase
    letter-spacing: 0.02em
    background: rgba(0, 0, 0, 0.06)
    color: $--color-text-secondary
    &.status-pending
        background: rgba(255, 152, 0, 0.15)
        color: #b26a00
    &.status-approved
        background: rgba(76, 175, 80, 0.15)
        color: #2e7d32
    &.status-rejected
        background: rgba(244, 67, 54, 0.15)
        color: #c62828

.shipmentLabel
    cursor: pointer
    color: black
    text-decoration: underline
.ml12
    margin-left: 8px

.status-dialog
    .drawer-footer
        margin-top: 30px
    .el-input
        margin-top: 20px

.el-input.mt0
    margin-top: 0px

.shipping-confirmation + .shipping-confirmation
    margin-top: 0.8rem

.right.flex-row
    align-items: center

.spinner
    width: 1rem
    height: 1rem
    top: -12px
    left: auto
    right: 0
</style>
